import {  useNavigate } from "react-router-dom";
import { APP_RETIREMENT_URLS } from "../../const/AppConst";
import useAppState from "../../context/AppContext";
import StickButtonsBloc from "../common/StickButtonsBloc";
import { useState } from "react";
import LoaderModal from "../../modals/common/LoaderModal";
import DocumentRequiredElement from "../../components/common/DocumentRequiredElement";

import { isMobile } from "../../utils/utils";
import ImageModal from "../../modals/common/ImageModal";

export default function REBienvenueBloc() {

    const navigate = useNavigate();
    const {
        state: { proposition },
        dispatch,
      } = useAppState();

    const [isLoading, setIsLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState<string>('');


    const onNextAction = async () => {
        const nextUrl = APP_RETIREMENT_URLS.situationPage
       
        dispatch({type: 'NEXT_INFO_STEP', path: nextUrl});
        navigate({
            pathname: nextUrl,
            search: `?id=${proposition!.propositionId}`,
        });         
    }

    const handleOpenInfoModal = (content: string) => {
      setImageUrl(content);
    }

    const handleCloseInfoModal = () => {
      setImageUrl('');
    }

  
    return (
        <>
        <div className="">
            <div className="grid-flex page-content">
            <div className="col-flex-4">
                <div className="">
                <p className="fw-bold fz-lg box-subTitle">Avant de poursuivre le parcours, nous vous invitons à préparer les documents suivants</p>
                <div className="quick-bloc" style={isMobile() ? {} : {height: "33cap"}}>
                    <div className="bg-bleu col-flex-3 ta-center pt-lg">
                    <div className="m-y-lg bloc-icon">
                        <i className="icon-personne blanc fz-lg"/>
                        <p className="fz-md blanc fw-bold p-x-lg bloc-icon mt-xs">Pour vous</p>
                    </div>
                    </div>
                    <div className="bg-blanc col-flex-8 p-xs">
                        <DocumentRequiredElement icon='icon-check'
                            title="Copie de votre pièce d'identité"
                            text="Carte d'identité ou passeport"
                        />
                        <DocumentRequiredElement icon='icon-check'
                            title="Attestation de droits à l'Assurance maladie"
                            text="Une attestation à jour que vous pouvez télécharger depuis le lien suivant <a href='https://www.ameli.fr' target='_blank' class='link'>https://www.ameli.fr</a>"
                            infoText={true}
                            handleClick={() => handleOpenInfoModal("Image_AM.jpg")}
                        />

                        <DocumentRequiredElement icon='icon-check'
                            title="Relevé d'identité bancaire"
                            text="Pour vous faire rembourser"
                        />

                        <DocumentRequiredElement icon='icon-check'
                            title="Pension de retraite"
                            text="Votre justificatif de pension "
                        />

                        <DocumentRequiredElement icon='icon-check'
                            title="Justificatif attestant du dernier employeur"
                            text=""
                            // infoText={true}
                            // handleClick={() => handleOpenInfoModal("Image_AM.jpg")}
                            tooltip="Pour les fonctionnaires : arrêté ministériel indiquant la date de début de retraite + dernier bulletin de salaire (dont la date doit être en cohérence avec le début de retraite).
                                Pour les non fonctionnaires : Notification de retraite (qui porte la date de début) + dernier bulletin de salaire (dont la date doit être en cohérence avec le début de retraite).
                                Pour tous : attestation sur l’honneur attestant de l’absence de reprise d’une activité rémunérée"

                        />
                    </div>
                </div>

                </div>
            </div>
            {!isMobile() && <div className=""></div>}
            <div className="col-flex-4">
                <p className="fw-bold fz-lg box-subTitle"></p>
                <div className="">
                
                <div className="quick-bloc" style={isMobile() ? {} : {height: "33cap"}}>
                    <div className="bg-bleu col-flex-3 ta-center pt-xs">
                    <div className="m-y-lg bloc-icon">
                        <img src={process.env.REACT_APP_RESSOURCE_BASE_URL + "/img/Picto_proches_B.svg"} width="80" height="80" style={{boxShadow: "none"}} alt=""/>
                        <p className="fz-md blanc fw-bold p-x-lg bloc-icon">Pour vos ayants droit</p>
                    </div>
                    </div>
                    <div className="bg-blanc col-flex-8 p-xs">
                        <DocumentRequiredElement icon='icon-check'
                            title="Attestation de droits à l'Assurance maladie"
                            text="Pour votre conjoint et vos enfants de plus de 16 ans"
                        />
                        <DocumentRequiredElement icon='icon-check'
                            title="Justificatif de situation familiale"
                            text="Livret de famille, PACS ou justificatif de domicile commun et attestation sur l'honneur."
                        />
                         <DocumentRequiredElement icon='icon-check'
                            title="Justificatif de reconnaissance d’handicap"
                            text=""
                            tooltip=" Justificatif de l'attribution d'une carte mobilité inclusion portant la mention invalidité ou de l'AAH si vous avez des enfants dans cette situation."

                        />
                        <DocumentRequiredElement icon='icon-check'
                            title="Autres documents"
                            text="Certificat de scolarité, contrat d'apprentissage ou de professionnalisation ou justificatif de recherche d'un premier emploi pour vos enfants de plus de 21 ans."
                        />
                       
                    </div>
                </div>
                
                </div>
                <div>
                
                </div>
            </div>

            </div>
        </div>

        <a 
            href="https://www.mgp.fr/psc-mi/agent-retraite.html" 
            target="_blank">
                <button className="cta-inline-bleu">
                    <span className="fz-lg">
                        Une question ? Trouvez votre réponse ici
                    </span>
                </button>
        </a>
        <StickButtonsBloc showPreviousButton={false} disabledPreviousButton={false} nextAction={onNextAction} nextButtonName={'Je démarre'} showNextButton={true}/>

        {imageUrl && <ImageModal isOpen={true} name={imageUrl} onCloseModal={handleCloseInfoModal}/>}
            
        {isLoading&&<LoaderModal hasMessage={false}/>}
        </>
    );
  }